export const dashboard = {
  "title": "Intuicyjny pulpit nawigacyjny",
  "subtitle": "Zarządzaj wszystkimi swoimi wymianami z prostego i nowoczesnego interfejsu",
  "features": {
    "stats": {
      "title": "Szczegółowe statystyki",
      "description": "Śledź swoje Troki, wymiany i oszczędności w czasie rzeczywistym"
    },
    "notifications": {
      "title": "Inteligentne powiadomienia",
      "description": "Otrzymuj alerty o nowych prośbach i ważnych wiadomościach"
    },
    "management": {
      "title": "Uproszczone zarządzanie",
      "description": "Zarządzaj dostępnością, rezerwacjami i wymianami kilkoma kliknięciami"
    }
  },
  "cta": "Odkryj pulpit nawigacyjny",
  "exchangeConfirmed": "Wymiana potwierdzona",
  "newRequests": "nowe prośby",
  "toReview": "Do sprawdzenia"
};
